import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Box, Center } from "@thecb/components";
import InternalUserInfo from "@/components/internalUserInfo";

const PROFILE = "PROFILE";

const ProfilePage = ({
  actions,
  alertBars,
  closeProfileForm,
  currentUserState,
  forms,
  handleResetPasswordUrl,
  openChangePasswordForm,
  resetPasswordUrl,
  submitProfileForm,
}) => {
  const {
    forms: { profileForm: profileFormActions },
    alertBars: { editProfileAlertBar: editProfileAlertBarAction },
  } = actions;

  const { editProfileAlertBar } = alertBars;
  const { profileForm } = forms;
  const history = useHistory();

  useEffect(() => {
    if (resetPasswordUrl) {
      window.open(resetPasswordUrl, "_blank");
      handleResetPasswordUrl(false);
    }
  }, [handleResetPasswordUrl, resetPasswordUrl]);

  return (
    <Center maxWidth="496px">
      <Box padding="0" width="496px">
        <InternalUserInfo
          form={profileForm}
          formActions={profileFormActions}
          formType={PROFILE}
          submitType={submitProfileForm}
          alertBar={editProfileAlertBar}
          alertBarActions={editProfileAlertBarAction}
          closeForm={() => closeProfileForm({ history })}
          userBeingEdited={currentUserState}
          openChangePasswordForm={openChangePasswordForm}
          currentUserState={currentUserState}
        />
      </Box>
    </Center>
  );
};

export default ProfilePage;
